import { WithSubpages } from '../../subpages';
import { PAGE_TITLE } from '../../consts';
import { customerValidationSubpages } from '../../subpages/dictionary';

import { MAIN_PAGE_PATH } from './paths';

const CUSTOMER_VALIDATION = () => (
  <WithSubpages
    mainPagePath={MAIN_PAGE_PATH}
    title={PAGE_TITLE.CUSTOMER_VALIDATION}
    items={customerValidationSubpages}
  />
);

export default CUSTOMER_VALIDATION;
